var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"by_law"},[_c('div',{staticClass:"by_law-list"},_vm._l((_vm.byLaws),function(item,index){return _c('LawNormFormByLawsItem',{key:index,attrs:{"item":item,"by-laws":_vm.selectByLaws},on:{"remove":_vm.removeByLaw,"clear":_vm.clear,"change":_vm.changeByLaw}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }